peopleHandler = {
    $itemFront          : $('.item-front'),
    $closeItem          : $('[href="#close-corporate-item"]'),
    $thumbnailContainer : $('.thumbnail-container:not(.no-resize)'),
    $closeSingle        : $('[href="#close-single-people"]'),

    resizeThumbnail : function() {
        var self = this;
        if (self.$thumbnailContainer.length > 0) {
            self.$thumbnailContainer.each(function() {
                var thumbnail = $(this).find('.thumbnail-image');
                var thumbnailBorder = $(this).find('.thumbnail-border');

                var newHeight = $(thumbnail).width() / 1.12;

                $(thumbnail).css('height', newHeight);
                $(thumbnailBorder).css('height', newHeight);
            });
        }
    },

    init : function() {
        var self = this;

        if (Foundation.MediaQuery.only('small')) {
            self.$itemFront.on('click', function(e) {
                if (!$(this).parent().find('.item-back').hasClass('is-showing')) {
                    $(this).parent().find('.item-back').addClass('is-showing');
                }
            });

            self.$closeItem.on('click', function(e) {
                e.preventDefault();

                if ($(this).parent().hasClass('is-showing')) {
                    $(this).parent().removeClass('is-showing');
                }
            });
        }

        /* self.$closeSingle.on('click', function(e) {
            e.preventDefault();

            history.go(-1);
        }); */

        $(window).on('load resize', function(e) {
            self.resizeThumbnail();
        });
    }
}